import request from './network'

// 获取环节配置详情
export function LevelConfig(query) {
    return request({
        url: '/monitor/levelConfig',
        method: 'get',
        params: query
    })
}

// 获取环节配置-层级列表
export function SelectCol(query) {
    return request({
        url: '/tacheConfig/selectCol',
        method: 'get',
        params: query
    })
}

// 环节配置
export function LevelConfigEdit(query) {
    return request({
        url: '/monitor/levelConfigEdit?projectId=' + query.projectId,
        method: 'post',
        data: JSON.stringify(query.table)
    })
}

// 获取select列表数据
export function LevelSelect(query) {
    return request({
        url: '/monitor/levelSelect',
        method: 'get',
        params: query
    })
}

// 获取区域检录统计列表数据
export function ListByCondition(query) {
    return request({
        url: '/monitor/listByCondition',
        method: 'post',
        data: query
    })
}

// 区域检录统计-查看表格未通过数据
export function ListByFailed(query) {
    return request({
        url: '/monitor/listByFailed',
        method: 'post',
        data: query
    })
}

// 获取最小层级监控列表数据
export function GetMonitorList(query) {
    return request({
        url: '/minimalLevelOfMonitoringController/getMinimalLevelOfMonitoring',
        method: 'post',
        data: query
    })
}

// 获取当前最小区域层级所包含人数是否超过100人
export function GetMonitorStatus(query) {
    return request({
        url: '/minimalLevelOfMonitoringController/monitorStatus',
        method: 'get',
        params: query
    })
}

// 最小层级监控列表-获取查看（1-未识别、2-未通过、3-通过1、4-通过2）考生数据
export function GetStudentInfo(query) {
    return request({
        url: '/minimalLevelOfMonitoringController/getInformationStudentWhoHaveFailed',
        method: 'post',
        data: query
    })
}

// 获取检录状态明细列表数据
export function DetailList(query) {
    return request({
        url: '/monitor/detailList',
        method: 'post',
        data: query
    })
}

// 检录状态明细-查看详情
export function DetailInfo(query) {
    return request({
        url: '/monitor/detailInfo',
        method: 'get',
        params: query
    })
}

// 检录小组进度-查询面试环节学生状态
export function InterviewGroup(query) {
    return request({
        url: '/monitor/interviewGroup',
        method: 'get',
        params: query
    })
}

// 配置进度查看-获取面试环节配置
export function InterviewSession(query) {
    return request({
        url: '/monitor/interviewSession',
        method: 'get',
        params: query
    })
}

// 配置进度查看-更新面试环节配置
export function UpdateInterviewSession(query) {
    return request({
        url: '/monitor/updateInterviewSession',
        method: 'post',
        data: query
    })
}
